export const CNSiteForms = [
  {
    code: "CN_Monthly_PreemptionAndAAWS_FRA234_261",
    description: "Preemption and AAWS (FRA 234.261) Monthly",
  },
  {
    code: "CN_Monthly_GeneratorAtsTest",
    description: "Generator ATS Test Monthly",
  },
  {
    code: "CN_Monthly_ACAndDCMode",
    description: "AC/DC Mode Test Monthly",
  },
  {
    code: "CN_Monthly_Bell_FRA234_257",
    description: "Bell Test (FRA 234.257) Monthly",
  },
  {
    code: "CN_Monthly_ACVoltage",
    description: "AC Voltage (AC/DC lit) Monthly",
  },
  {
    code: "CN_Monthly_PrimaryApproachCircuits",
    description: "Primary Approach Circuits Test Monthly",
  },
  {
    code: "CN_Monthly_CWMSDevices",
    description: "CW/MS Devices Test Monthly",
  },

  {
    code: "CN_Monthly_LightUnitsAndSigns_FRA234_253",
    description: "Light Units and Signs (FRA 234.253) Monthly",
  },
  {
    code: "CN_Monthly_GateArmsAndMechanism_FRA234_255ab",
    description: "Gate Arm and Mechanism (FRA 234.255ab) Monthly",
  },
  {
    code: "CN_Monthly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251",
    description: "Primary Battery and Grounds (FRA 236.107, FRA 234.249 and FRA 234.251) Monthly",
  },
  {
    code: "CN_Monthly_SecondaryBatteryAndGrounds_FRA234_249And234_251",
    description: "Secondary Battery and Grounds (FRA 234.249 and 234.251) Monthly",
  },
  {
    code: "CN_Monthly_ControllingDevices_FRA234_257ab",
    description: "Warning System Operation (FRA 234.257ab) Monthly",
  },

  {
    code: "CN_Quarterly_GeneratorInspection",
    description: "Generator Inspection Quarterly",
  },
  {
    code: "CN_Quarterly_CutoutCircuits_FRA234_269",
    description: "Cut-out circuits (FRA 234.269) Quarterly",
  },
  {
    code: "CN_Quarterly_InsulatedJointsAndTrackConnections_FRA234_271",
    description: "Insulated Joints and Track Connections (FRA 234.271) Quarterly",
  },

  {
    code: "CN_Quarterly_PrimaryBatteryAndGrounds_FRA236_107And234_249And234_251",
    description: "Primary Battery and Grounds (FRA 236.107, FRA 234.249 and FRA 234.251) Quarterly",
  },
  {
    code: "CN_Quarterly_SecondaryBatteryAndGrounds_FRA234_249And234_251",
    description: "Secondary Battery and Grounds (FRA 234.249 and 234.251) Quarterly",
  },

  {
    code: "CN_Annual_GateArmsAndMechanism_FRA234_255",
    description: "Annual Gate Mechanisms (FRA 234.255)",
  },
  {
    code: "CN_Annual_BatteryLoad",
    description: "Annual Battery Load Test",
  },
  {
    code: "CN_Annual_PrimaryBatteryExhuastion",
    description: "Annual Primary Battery Exhaustion",
  },
  {
    code: "CN_Annual_LightUnitAlignmentFRA234_253",
    description: "Annual Light Unit Alignment (FRA 234.253)",
  },
  {
    code: "CN_Annual_ApproachesWithCWMS",
    description: "Annual Approaches with MS/CW",
  },
  {
    code: "CN_Annual_GeneracGeneratorInspection",
    description: "Annual Generac Generator Inspection",
  },
  {
    code: "CN_Annual_GeneratorInspection",
    description: "Annual Generator Inspection",
  },
  {
    code: "CN_Annual_CableHousing",
    description: "Annual Inspection of Cable Housing Test",
  },
  {
    code: "CN_Annual_ConditionOfPlans_FRA234_201And236_1",
    description: "Annual Condition of Plans Test (FRA 234.201 and 236.1)",
  },
  {
    code: "CN_Annual_FlashRate_FRA234_253",
    description: "Annual Flashing Rate (FRA 234.253)",
  },
  {
    code: "CN_Annual_LampVoltageFRA234_253",
    description: "Annual Lamp Voltages (FRA 234.253)",
  },
  {
    code: "CN_Annual_WarningTime_FRA234_259",
    description: "Annual Warning Time (FRA 234.259)",
  },
  {
    code: "CN_Annual_TimingDevices_FRA234_265",
    description: "Annual Timing Devices (FRA 234.265)",
  },
  {
    code: "CN_2Year_GeneratorInspection",
    description: "2 Year Generator Inspection",
  },
  {
    code: "CN_10Y_FRA236_267And236_108",
    description: "10 Year Insulation Resistance Test",
  },
];

export const FRASiteTests = [
  {
    code: "FRA234_269",
    description: "Cut-out circuits",
  },

  {
    code: "FRA234_253A",
    description: "Flashing light units and lamp voltage Annual",
  },
  {
    code: "FRA234_253M",
    description: "Flashing light units and lamp voltage Monthly",
  },

  {
    code: "FRA234_255",
    description: "Gate arm and gate mechanism",
  },

  {
    code: "FRA234_249",
    description: "Ground tests",
  },
  {
    code: "FRA234_255c",
    description: "Hold-clear devices",
  },
  { code: "FRA234_271", description: "Insulated rail joints, bond wires, and track connections" },

  {
    code: "FRA234_267And236_108",
    description: "Insulation resistance tests, wires in trunking and cables",
  },
  { code: "FRA234_253_LV", description: "Lamp Voltages" },

  { code: "FRA234_253_LA", description: "Light Alignment" },

  {
    code: "FRA234_263And236_106",
    description: "Relays",
  },

  {
    code: "2YearRelayTest",
    description: "Relays",
  },

  {
    code: "4YearRelayTest",
    description: "Relays",
  },
  {
    code: "FRA234_251",
    description: "Standby power",
  },
  {
    code: "FRA234_265",
    description: "Timing Relay Test",
  },
  {
    code: "FRA234_261",
    description: "Highway traffic signal pre-emption",
  },
  {
    code: "FRA234_257",
    description: "Warning system operation",
  },

  {
    code: "FRA234_259",
    description: "Warning time",
  },
  ...CNSiteForms,
];



// WEBPACK FOOTER //
// ./src/components/Reports/sims/FRA_Crossing/CombinedForms.js